export default __webpack_public_path__ + "static/media/ballroomGood.5198bbcc.png";